import React , {createRef} from "react";
import "./ModulePreviewData.scss";
import SingleLinekeyValue from "./SingleLineKeyValue";
import BusinessRulesPreview from "./BusinessRulesPreview";
import Tooltip from "@mui/material/Tooltip";

const popoverRef = createRef();

function ModulePreviewData(props) {
  const { modulePreviewData, activePreviwData, generatePdf } = props;

  const reusableTextTypes = [
    {
      name: "copy__v",
      label: "Copy",
    },
    {
      name: "headline__v",
      label: "Headline",
    },
    {
      name: "objective__v",
      label: "Objective",
    },
    {
      name: "strapline__v",
      label: "Strapline",
    },
    {
      name: "summary__v",
      label: "Summary",
    },
    {
      name: "tagline__v",
      label: "Tagline",
    },
    {
      name: "teaser__v",
      label: "Teaser",
    },
    {
      name: "title__v",
      label: "Title",
    },
  ];
  function getLabelByName(name) {
    const item = reusableTextTypes.find((item) => item.name === name);
    return item ? item.label : null;
  }
  const getSvgCDNLinks = (fileName) => {
    return modulePreviewData?.logos?.find((item) => item.includes(fileName));
  };
  const getMlrStatusIcon = (mlrStatus) => {
    if (!mlrStatus) return getSvgCDNLinks("infoIcon.svg");

    const trimmedStatus = mlrStatus.trim().toLowerCase();

    if (trimmedStatus.includes("draft")) {
      return getSvgCDNLinks("statusDraft.svg");
    } else if (trimmedStatus.includes("available")) {
      return getSvgCDNLinks("statusApproved.svg");
    } else if (trimmedStatus.includes("expired")) {
      return getSvgCDNLinks("final-status.svg");
    } else {
      return getSvgCDNLinks("Intermediate.svg");
    }
  };

  return (
    <>
      <div
        id="modulePreviewContainer"
        className="pdfPreviewWidth custonScrollBar"
        ref={popoverRef}
      >
        <div
          className={`col-12 p-0 module-container-borderLine${
            !activePreviwData ? "cmsdTrackContainer" : null
          }`}
        >
          <div className="modulePreviewContainer">
            {generatePdf ? null : (
              <div className="modulePreviewHeader">
                <p>
                  {modulePreviewData?.countryName && (
                    <>
                      <span className="ml-0">Product:</span>{" "}
                      {modulePreviewData?.productName}
                    </>
                  )}
                  {modulePreviewData?.productName && (
                    <>
                      <span>Country:</span> {modulePreviewData?.countryName}
                    </>
                  )}
                  {modulePreviewData?.indications?.length > 0 && (
                    <>
                      <span>Indication:</span>{" "}
                      {modulePreviewData?.indications?.map(
                        (indication, index, array) => (
                          <>
                            {indication.indicationName}
                            {index < array.length - 1 ? ", " : ""}
                          </>
                        )
                      )}
                    </>
                  )}

                  {modulePreviewData?.languageName && (
                    <>
                      <span>Language:</span> {modulePreviewData?.languageName}
                    </>
                  )}
                  {modulePreviewData?.topicName && (
                    <>
                      <span>Topic:</span> {modulePreviewData?.topicName}
                    </>
                  )}
                  {modulePreviewData?.subtopicName && (
                    <>
                      <span>Sub-Topic:</span> {modulePreviewData?.subtopicName}
                    </>
                  )}
                </p>

                {modulePreviewData?.audienceName ||
                modulePreviewData?.segments?.length > 0 ||
                modulePreviewData?.strategicObjectives?.length > 0 ||
                modulePreviewData?.languageName ? (
                  <>
                    <p>
                      {modulePreviewData?.audienceName && (
                        <>
                          <span className="ml-0">Audience:</span>{" "}
                          {modulePreviewData?.audienceName}
                        </>
                      )}
                      {modulePreviewData?.therapeuticAreaName && (
                        <>
                          <span>Therapeutic Area:</span>{" "}
                          {modulePreviewData?.therapeuticAreaName}
                        </>
                      )}
                      {modulePreviewData.segments.length > 0 && (
                        <>
                          <span>Segment:</span>{" "}
                          {modulePreviewData.segments.map(
                            (indication, index, array) => (
                              <>
                                {indication.segmentName}
                                {index < array.length - 1 ? ", " : ""}
                              </>
                            )
                          )}
                        </>
                      )}

                      {modulePreviewData?.strategicObjectives?.length > 0 && (
                        <>
                          <span>Strategic Objective:</span>{" "}
                          {modulePreviewData?.strategicObjectives?.map(
                            (indication, index, array) => (
                              <>
                                {indication.strategicObjName}
                                {index < array.length - 1 ? ", " : ""}
                              </>
                            )
                          )}
                        </>
                      )}
                    </p>
                    <p className="mb-0">
                      {modulePreviewData?.moduleDraftElementIncluded?.length >
                        0 && (
                        <>
                          <span className="ml-0">
                            Draft Elements Included?:
                          </span>{" "}
                          {modulePreviewData?.moduleDraftElementIncluded?.map(
                            (indication, index, array) => (
                              <>
                                {indication.draftElementIncludedName}
                                {index < array.length - 1 ? ", " : ""}
                              </>
                            )
                          )}
                        </>
                      )}
                      {modulePreviewData?.communicationObjectives && (
                        <>
                          <span
                            className={
                              modulePreviewData?.moduleDraftElementIncluded
                                ?.length > 0
                                ? "ml-0 marginLeftCommunication"
                                : "ml-0"
                            }
                            style={{ marginLeft: "20px !important" }}
                          >
                            {" "}
                            Communication Objectives:
                          </span>{" "}
                          {modulePreviewData?.communicationObjectives}
                        </>
                      )}
                    </p>
                  </>
                ) : null}
              </div>
            )}
            {modulePreviewData?.claims &&
              modulePreviewData?.claims?.map((claim) => (
                <>
                  {claim.trackChangeValue && (
                    <div>
                      <span
                        className={
                          claim.trackChangeValue === "new"
                            ? "newData"
                            : claim.trackChangeValue === "old"
                            ? "newData oldData"
                            : ""
                        }
                      >
                        {claim.trackChangeValue}
                      </span>
                    </div>
                  )}
                  <div
                    className={`d-flex moduleClaimSection ${
                      claim.trackChangeValue === "new"
                        ? "trackChangeValue"
                        : claim.trackChangeValue === "old"
                        ? "trackChangeValue old"
                        : ""
                    }`}
                    key={claim.claimId}
                  >
                    <div>
                      <div className={`d-flex align-items-center`}>
                        <div className="claimBoxBrdr">
                          <div className="claimType">CLAIM</div>
                          <div className="damStatus">
                            {claim.mustUse ? (
                              <>
                                <span>
                                  <img
                                    src={getSvgCDNLinks("mustUseRedDot.svg")}
                                    alt=""
                                  />
                                </span>{" "}
                                <span>Must Use</span>
                              </>
                            ) : (
                              <>
                                <span>
                                  <img
                                    src={getSvgCDNLinks("mustUseGreenDot.svg")}
                                    alt=""
                                  />
                                </span>{" "}
                                <span>Optional</span>
                              </>
                            )}
                          </div>
                          <div className="claimId">
                            PromoMats ID:{" "}
                            <span className="image-claimName">
                              <Tooltip title={claim?.mlrStatus || ""}>
                                <img
                                  style={{ verticalAlign: "unset" }}
                                  src={getMlrStatusIcon(claim?.mlrStatus)}
                                  alt={claim?.mlrStatus || ""}
                                />
                              </Tooltip>
                              <div>{claim?.claimName}</div>
                            </span>
                          </div>
                        </div>
                        <div>
                          <img
                            src={getSvgCDNLinks("modulePreviewArrow.svg")}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div className="claimDetailsBox">
                      <p className="mb-0 claimText">{claim.matchText}</p>

                      {claim.matchTextVariants &&
                        claim.matchTextVariants.map((variant, index) => (
                          <>
                            <p className="captionText">Variation {index + 1}</p>
                            <p className="mb-0 claimText">
                              {" "}
                              {variant.matchText}
                            </p>
                          </>
                        ))}

                      {claim.footnotes && (
                        <p className="captionText">Footnote</p>
                      )}
                      <p className="relatedText">{claim.footnotes}</p>
                      {claim.references.length > 0 && (
                        <p className="captionText">Reference</p>
                      )}
                      <div className="relatedText">
                        {claim.references.map((reference, refIndex) => (
                          <p
                            className="d-block"
                            style={{ marginBottom: "5px" }}
                          >
                            ({refIndex + 1}) {reference.documentName}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
              ))}
            {modulePreviewData?.claims?.length > 0 && (
              <div className="sectionDevider"></div>
            )}
            {modulePreviewData?.reusableTexts?.length > 0 && (
              <>
                {modulePreviewData?.reusableTexts?.map(
                  (reusableText, index) => (
                    <div key={index}>
                      {reusableText.trackChangeValue && (
                        <div>
                          <span
                            className={
                              reusableText.trackChangeValue === "new"
                                ? "newData"
                                : reusableText.trackChangeValue === "old"
                                ? "newData oldData"
                                : ""
                            }
                          >
                            {reusableText.trackChangeValue}
                          </span>
                        </div>
                      )}
                      <div
                        className={`d-flex align-items-center  moduleClaimSection ${
                          reusableText.trackChangeValue === "new"
                            ? "trackChangeValue"
                            : reusableText.trackChangeValue === "old"
                            ? "trackChangeValue old"
                            : ""
                        }`}
                      >
                        <div className={`d-flex align-items-center`}>
                          <div className="claimBoxBrdr">
                            <div className="claimType">Reusable text</div>
                            {reusableText.mustUse ? (
                              <>
                                <div className="damStatus">
                                  <span>
                                    <img
                                      src={getSvgCDNLinks("mustUseRedDot.svg")}
                                      alt=""
                                    />
                                  </span>{" "}
                                  <span>Must Use</span>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="damStatus">
                                  <span>
                                    <img
                                      src={getSvgCDNLinks(
                                        "mustUseGreenDot.svg"
                                      )}
                                      alt=""
                                    />
                                  </span>{" "}
                                  <span>Optional</span>
                                </div>
                              </>
                            )}
                            <div className="claimTypeText">
                              Type: <span>{reusableText.textType}</span>
                            </div>
                            <div className="claimId">
                              PromoMats ID:{" "}
                              <span className="image-claimName">
                                <Tooltip title={reusableText?.mlrStatus || ""}>
                                  <img
                                    style={{ verticalAlign: "unset" }}
                                    src={getMlrStatusIcon(
                                      reusableText?.mlrStatus
                                    )}
                                    alt={reusableText?.mlrStatus}
                                  />
                                </Tooltip>
                                <div>{reusableText.reusableTextName}</div>
                              </span>
                            </div>
                          </div>
                          <div>
                            <img
                              src={getSvgCDNLinks("modulePreviewArrow.svg")}
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="claimDetailsBox">
                          <div>
                            {reusableText.textType !== "call_to_action__c" ? (
                              <p className="mb-0 claimText">
                                {reusableText.matchText}
                              </p>
                            ) : (
                              <>
                                <p className="mb-0 claimText">
                                  {reusableText.matchText}
                                </p>
                                <p className="captionText">Link</p>
                                <p className="relatedText"> </p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
                <div className="sectionDevider"></div>
              </>
            )}
            {modulePreviewData?.components?.length > 0 &&
              modulePreviewData?.components.map((component, index) => (
                <div className="d-flex moduleClaimSection" key={index}>
                  <div>
                    <div className={`d-flex align-items-center`}>
                      <div className="claimBoxBrdr">
                        <div className="claimType">Component</div>
                        <div className="damStatus">
                          {component.mustUse ? (
                            <>
                              <div className="damStatus">
                                <span>
                                  <img
                                    src={getSvgCDNLinks("mustUseRedDot.svg")}
                                    alt=""
                                  />
                                </span>{" "}
                                <span>Must Use</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="damStatus">
                                <span>
                                  <img
                                    src={getSvgCDNLinks("mustUseGreenDot.svg")}
                                    alt=""
                                  />
                                </span>{" "}
                                <span>Optional</span>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="claimTypeText">
                          Sub-Type: <span>{component.subType}</span>
                        </div>

                        <div className="claimId">
                          PromoMats ID:{" "}
                          <span className="image-claimName">
                            <Tooltip title={component?.mlrStatus || ""}>
                              <img
                                style={{ verticalAlign: "unset" }}
                                src={getMlrStatusIcon(component?.mlrStatus)}
                                alt={component?.mlrStatus}
                              />
                            </Tooltip>
                            <div>{component.componentDocNumber}</div>
                          </span>
                        </div>
                      </div>
                      <div>
                        <img
                          src={getSvgCDNLinks("modulePreviewArrow.svg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="claimDetailsBox">
                    {component.trackChangeValue && (
                      <div>
                        <span
                          className={
                            component.trackChangeValue === "new"
                              ? "newData"
                              : component.trackChangeValue === "old"
                              ? "newData oldData"
                              : ""
                          }
                        >
                          {component.trackChangeValue}
                        </span>
                      </div>
                    )}
                    <img
                      src={component.componentUrl}
                      alt=""
                      className="mb-2 img-fluid"
                    />
                    {(component?.title || component?.matchText) &&
                    component.subType !== "Data Graphic" ? (
                      <>
                        <p className="captionText">TITLE</p>
                        <p className="mb-0 relatedText">
                          {component.matchText
                            ? component.matchText
                            : component.title}
                        </p>
                      </>
                    ) : (
                      <>
                        {component?.relatedClaims?.length > 0 && (
                          <p className="captionText">
                            RELATED CLAIMS ({component?.relatedClaims?.length})
                          </p>
                        )}
                        {component.relatedClaims?.map((item, index) => (
                          <div style={{ marginBottom: "20px" }} key={index}>
                            <SingleLinekeyValue
                              label="ID"
                              value={
                                <>
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      marginRight: "4px",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    <span className="mr-1"></span>
                                  </div>
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {item?.claimName}
                                  </span>
                                  {item?.mlrStatus
                                    ?.trim()
                                    .toLowerCase()
                                    .includes("expired") && (
                                    <span
                                      className="Expired"
                                      style={{
                                        verticalAlign: "middle",
                                        marginBottom: "-2px",
                                      }}
                                    >
                                      Expired
                                    </span>
                                  )}
                                </>
                              }
                              inline={true}
                            />
                            <p
                              className="mb-0 claimText"
                              style={{ marginTop: "12px" }}
                            >
                              {item.matchText}
                            </p>
                            {item.footnotes && (
                              <>
                                <p className="captionText">FOOTNOTE</p>
                                <p className="mb-0 relatedText">
                                  {item.footnotes ? item.footnotes : ""}
                                </p>
                              </>
                            )}
                            {item.references?.length > 0 && (
                              <>
                                <p className="captionText">Reference</p>
                                <p className="relatedText">
                                  {item.references?.map(
                                    (reference, refIndex) => (
                                      <span className="d-block" key={refIndex}>
                                        ({refIndex + 1}){" "}
                                        {reference.documentName}
                                      </span>
                                    )
                                  )}
                                </p>
                              </>
                            )}
                          </div>
                        ))}
                        {component?.relatedReusableTexts?.length > 0 && (
                          <p className="captionText">
                            Related Reusable Texts (
                            {component?.relatedReusableTexts?.length})
                          </p>
                        )}
                        {component.relatedReusableTexts?.map(
                          (item, refIndex) => (
                            <div
                              style={{ marginBottom: "20px" }}
                              key={refIndex}
                            >
                              <SingleLinekeyValue
                                label="ID"
                                value={
                                  <>
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        marginRight: "4px",
                                        marginLeft: "3px",
                                      }}
                                    >
                                      <span className="mr-1"></span>
                                    </div>
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {item.reusableTextName}
                                    </span>
                                    {item?.mlrStatus
                                      ?.trim()
                                      .toLowerCase()
                                      .includes("expired") && (
                                      <span
                                        className="Expired"
                                        style={{
                                          verticalAlign: "middle",
                                          marginBottom: "-2px",
                                        }}
                                      >
                                        Expired
                                      </span>
                                    )}
                                  </>
                                }
                                inline={true}
                              />
                              <p
                                className="mb-0 claimText"
                                style={{ marginTop: "12px" }}
                              >
                                {item.matchText}
                              </p>
                            </div>
                          )
                        )}
                      </>
                    )}
                    {component.footnotes && (
                      <>
                        <p className="captionText">FOOTNOTE</p>
                        <p className="mb-0 relatedText">
                          {component.footnotes ? component.footnotes : ""}
                        </p>
                      </>
                    )}

                    {component.references?.length > 0 && (
                      <p className="captionText">Reference</p>
                    )}
                    <p className="relatedText">
                      {component.references?.map((reference, refIndex) => (
                        <span className="d-block">
                          ({refIndex + 1}) {reference.documentName}
                        </span>
                      ))}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          {modulePreviewData?.businessRulesTrackChanges && (
            <>
              <div>
                <span className="bsOld">Old</span>
              </div>
              <BusinessRulesPreview
                businessRules={
                  modulePreviewData?.businessRulesTrackChanges?.old
                }
                usageGuidelines={
                  modulePreviewData?.businessRulesTrackChanges
                    ?.usageGuidelines || ""
                }
              />
            </>
          )}
          {(modulePreviewData?.businessRules?.length > 0 ||
            modulePreviewData?.usageGuidelines ||
            modulePreviewData?.businessRulesTrackChanges) && (
            <>
              {modulePreviewData?.businessRulesTrackChanges && (
                <div>
                  <span className="newData">New</span>
                </div>
              )}
              <BusinessRulesPreview
                businessRules={modulePreviewData?.businessRules}
                usageGuidelines={modulePreviewData?.usageGuidelines || ""}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ModulePreviewData;
